import styled from 'styled-components';

export const Content = styled.div`
  form {
    margin: 0;
    padding: 0 0 5px;
  }
  &.loading {
    position: relative;
    min-height: 38px;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: -5px;
    top: -5px;
    right: -5px;
    bottom: -5px;
    z-index: 999;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.75) url(/images/loader.svg) no-repeat 50%;
  }
`;

export const Header = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
`;

export const Info = styled.label`
  font-size: 15px;
  display: block;
  cursor: pointer;
  font-weight: normal;
  margin-bottom: 10px;
  select {
    margin-left: 0.5rem;
  }
`;
